export default __webpack_public_path__ + "static/media/icon-login-email.5060853c.webp";